import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: Cookies.get('language'),
    backend: {
      /* translation file path */
      loadPath: '/{{ns}}/{{lng}}.json'
    },
    fallbackLng: ['en', 'tc', 'sc'],
    debug: true,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: '.',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  })

export default i18n;